
export default 'USBC will contact you within 1 business day.'


// WEBPACK FOOTER //
// ./src/containers/event/EventWizard/Participants/Constants/schoolNotFoundNotificationSent.js